export const HOME = '/'

export const AUTH = '/auth'
export const LOGIN = AUTH + '/login'
export const PORTAL_LOGIN = AUTH + '/portal-login'

export const COMPANY_LIST = '/company-list'

// In-app notifications (served by portal-service, public.notifications scoped to ERPBOI_MERCHANDISING).
// Reached from the topbar bell, not the sidebar, and not feature-gated: the feed is the caller's own.
export const NOTIFICATIONS = '/notifications'

// Where "/" and a denied route land. Not a page of its own: it forwards to the first screen the
// sidebar grants (pages/landing/Landing). It must
// NOT be a feature-guarded route — RequireFeature redirects here, so a guarded landing page would
// bounce a user without that feature back and forth.
export const LANDING = '/home'

// Merchandising. Every screen url below is a permission key stored in auth.features.url
// (sql/merchandising_02_catalog.sql) and compared by EXACT string equality — do not rename one without an
// in-place UPDATE of that row in BOTH databases. They share the /merchandising prefix because the
// ACL does not scope urls by app: a prefix unique to this module keeps them from colliding with
// another console's routes (desk already owns /teams).
export const MERCHANDISING = '/merchandising'

// Admin Config
export const MRC_TEAM = MERCHANDISING + '/team'

// Item Master Data
export const MRC_BUYER = MERCHANDISING + '/buyer'
// The buyer form is a routed page (it nests contacts, departments and their size lists); add needs
// the Buyer feature's Create, edit its Update.
export const MRC_BUYER_ADD = MRC_BUYER + '/add'
export const MRC_BUYER_EDIT: (p: {id: string}) => string = ({id}) => `${MRC_BUYER}/edit/${id}`
// The sales item catalogue: categories (with sub-categories), then one screen per kind.
export const MRC_ITEM_CATEGORY = MERCHANDISING + '/item-category'
export const MRC_FABRIC = MERCHANDISING + '/fabric'
export const MRC_ACCESSORY = MERCHANDISING + '/accessory'
export const MRC_STYLE = MERCHANDISING + '/style'
export const MRC_SEASON = MERCHANDISING + '/season'
// Garment items of the catalogue (a flat lookup until 2026-10-16; the url, the permission key, is unchanged).
export const MRC_GARMENT_ITEM = MERCHANDISING + '/garment-item'
export const MRC_RATE_TYPE = MERCHANDISING + '/rate-type'
export const MRC_FABRIC_PART = MERCHANDISING + '/fabric-part'
export const MRC_PROCESS = MERCHANDISING + '/process'
